import { ReactNode } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

type Props = {
    buttons: ReactNode;
    title: string | ReactNode;
    subTitle: string | ReactNode;
};

const SectionAppBar = ({ title, buttons, subTitle }: Props) => {
    return (
        <AppBar position="sticky" sx={{ mb: 4 }}>
            <Toolbar>
                <Box component="div" sx={{ flexGrow: 1 }}>
                    <Typography variant="h6" component="div" color="white">
                        {title}
                    </Typography>
                    <Typography variant="caption" component="div" color="white">
                        {subTitle}
                    </Typography>
                </Box>
                <Box display="flex" gap={2} flexGrow={1} justifyContent="flex-end">
                    {buttons}
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default SectionAppBar;
